/* eslint-disable no-unused-vars */
import React, { useEffect, useCallback, useState } from 'react';
import ClausesWrapper from '../../components/Clauses/ClausesWrapper';

function ClausesList() {
  return (
    <>
      <ClausesWrapper />
    </>
  );
}

export default ClausesList;
